<template>
  <div id="index">
    <Header />
    <DetailsProduct />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/template/Header";
import Footer from "@/components/template/Footer";
import DetailsProduct from "@/components/product/detail";

export default {
    data() {
        return {
            canalVendas: null,
        }
    },
  components: {
    Header,
    Footer,
    DetailsProduct,
  },
  methods: {
    async getDados() {
      let canal = JSON.parse(localStorage.getItem("saleChannel"));

      this.canalVendas = canal;

    },
  },

  beforeMount() {
      this.getDados();
  }
};
</script>